import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import email from '../../assets/email.svg';
import axios from 'axios';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const { REACT_APP_NODE_SERVER_BASE_URL } = process.env;

const ValidateEmailVerification = () => {
    const [searchParams] = useSearchParams();
    const { content } = useContentfulContext();

    const [response, setResponse] = useState("")
    const [message, setMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const resendEmailVerificationLink = async () => {
        try {
            if(!response?.user_id) return '';
            const uri = new URL(`${REACT_APP_NODE_SERVER_BASE_URL}/user/resend-verification-email`);
            uri.searchParams.append('user_id', response?.user_id)
            const result = await axios.post(uri,{ user_id: response?.user_id });
            setMessage(result.data.message);
            setErrorMessage("");
        } catch (error) {
            setMessage("")
            setErrorMessage(error?.response?.data?.message || "Something went wrong please try after sometime")
        }
    }

    useEffect(() => {
        if (searchParams.get("error")) {
            setResponse(JSON.parse(searchParams.get("error_description")))
        }
    }, [searchParams.get("error")])
    return (
        <section className='h-fit'>
            <div className="mx-auto flex flex-col md:flex-row items-center max-w-[75%] my-6">
                <div className="p-8 flex flex-col lg:w-1/2 justify-center items-start text-center m-auto my-9">
                    <div className="space-y-4 md:space-y-6 w-full">
                        <img src={email} alt="EMAIL" className='h-16' />
                        <h1 className="text-2xl font-bold leading-tight tracking-tight text-gray-900 md:text-3xl">
                        {content?.EMAIL_NOT_VERIFIED?.[response?.message]?.message}
                        </h1>
                        <div className="flex-col items-center">
                            <p htmlFor="terms" className="font-light text-gray-500">
                                {content?.EMAIL_NOT_VERIFIED?.[response?.message]?.description}
                            </p>
                        </div>
                        <p className="text-lg font-medium text-green-500">{message}</p>
                        <p className="text-lg font-medium text-red-500">{errorMessage}</p>
                        <button className="text-lg font-medium text-[#1038A5] hover:underline" onClick={resendEmailVerificationLink}>
                            {content?.EMAIL_VERIFICATION_CONTENT?.button?.resend_email}
                        </button>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ValidateEmailVerification;